// ----------------------------------------------------------------------------
// Snippet: Product Zoom
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------


// -------------------------------------
// Dependencies
// -------------------------------------

// Scripts
import 'snippets/_containers/modal/modal';

// Styles
import './_product-zoom.scss';


import $ from 'jquery';


$(() => {
       
    const modal = $('.modal--product-zoom');
    
    // Get Swiper Slides Content
    const swipperContent = $('.product__feature-image.carousel--featured-product.swiper .swiper-wrapper').children();
    let zoomModalContent = "";
    
    // Filter Video Slides
    swipperContent.each(function () {
        const slide = this;
        const slideVideo = slide.querySelector('.video-block');
        
        if (!slideVideo) zoomModalContent += slide.outerHTML;
    });
    
    // Clone Product media into modal
    $('.modal__content_media_container').html(zoomModalContent);
    
        
    // Opens modal when zoom button is clicked
    $('.media-zoom-button, .product-single__media-wrapper picture img').on( "click", (e) => {
        
        // Trigger Zoom only if Desktop
        if ($(window).width() < 1024) {
            return;
        }
        
        let imageID = e.target.closest('.product-single__media-wrapper').id;
            
        // Open the modal after the item is added
        modal.addClass('modal--open');
        
        $('body').addClass('noscroll');
        $('.shopify-section--header').addClass('sendback');
        
        // Used ES6 to scroll to the top of the image (jQuery's "scrollTop" does not work due to the modal's inside scroll)
        document.querySelector('.modal__content_media_container #'+imageID).scrollIntoView({block: "start"}); 
            
        // Broadcast a notification that a modal opened
        $(window).trigger('open.modal', modal);
            
    });
    
    // Closes modal when close buttons are clicked
    $('.close-zoom, .icon-close-zoom').on( "click", () => {
        //Trigger only if Desktop
        if ($(window).width() < 1024) {
            return;
        }  
        modal.removeClass('modal--open');
        
        $('body').removeClass('noscroll');
        $('.shopify-section--header').removeClass('sendback');
        
        // Broadcast a notification that a modal closed
        $(window).trigger('close.modal', modal);
    });
       
});